import { Link } from "../../app/navigation.js";
import { Avatar } from "../../art/Avatar.js";
import { useEffect, useState } from "react";
import { mobileCopy } from "../../app/mobileCopy.js";
import { useLocale } from "../../i18n.js";
import { api, type Leaderboard, type PlayerStats } from "../../net/api.js";
import { Button, EmptyState, PageHeader, Panel, SegmentedControl, Skeleton } from "../../ui/primitives.js";
import { Home, MeScreen } from "../MobileScreens.js";
import { Friends } from "../Friends.js";
import { WideStatsDashboard, type StatsTab } from "../Profile.js";
import { Replays } from "../Replays.js";
import "./wide-screens.css";

export function WideHome() { return <div className="wide-screen wide-home-screen"><Home wide /></div>; }
/** Wide composition shares social actions and server state with the mobile view. */
export function WideSocialScreen() { return <div className="wide-screen wide-form-screen wide-social-screen"><Friends wide /></div>; }
export function WideMeScreen() { return <div className="wide-screen wide-form-screen wide-me-screen"><MeScreen wide /></div>; }

export function WideRecordScreen() {
  const { locale } = useLocale();
  const c = mobileCopy.bind(null, locale);
  const [stats, setStats] = useState<PlayerStats | null>(null);
  const [board, setBoard] = useState<Leaderboard | null>(null);
  const [failed, setFailed] = useState(false);
  const [view, setView] = useState<StatsTab>("overview");
  useEffect(() => {
    let active = true;
    void Promise.all([api.stats(), api.leaderboard(50)]).then(([nextStats, nextBoard]) => {
      if (!active) return;
      setStats(nextStats); setBoard(nextBoard); setFailed(false);
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  return (
    <div className="wide-screen wide-record-screen">
      <PageHeader title={c("record")} />
      {failed ? <EmptyState title={c("couldNotLoad")} action={<Button onClick={() => window.location.reload()}>{c("retry")}</Button>} /> : stats === null || board === null ? <Skeleton lines={7} /> : (
        <>
          <Panel tone="accent" className="wide-season-summary">
            <span><small>{board.season.label}</small><strong>#{board.me?.rank ?? "—"}</strong></span>
            <span><small>{c("winRate")}</small><strong>{Math.round(stats.overview.winRate * 100)}%</strong></span>
            <span><small>{c("totalMatches")}</small><strong>{stats.overview.matches}</strong></span>
            <span><small>{c("bombCount")}</small><strong>{stats.play.bombs}</strong></span>
          </Panel>
          <div className="wide-record-main">
            <SegmentedControl
              className="wide-stats-tabs"
              label={c("record")}
              value={view}
              options={[
                { value: "overview", label: c("overview") },
                { value: "play", label: c("playStats") },
                { value: "competition", label: c("competitionStats") },
                { value: "economy", label: c("economyStats") },
              ]}
              onChange={setView}
            />
            <WideStatsDashboard stats={stats} view={view} />
            <Panel className="wide-season-board">
              <h2>{locale === "zh-CN" ? "赛季排行榜" : "Season leaderboard"}</h2>
              {board.top.length === 0 ? <p>{locale === "zh-CN" ? "完成排位对局，登上排行榜。" : "Play ranked matches to enter the leaderboard."}</p> : board.top.map((entry) => (
                <Link className="leader-row" to={`/player/${entry.userId}`} key={entry.userId}>
                  <b>#{entry.rank}</b><Avatar avatarId={entry.avatarId} size={36} /><span>{entry.name}</span><strong>{entry.rating}</strong>
                </Link>
              ))}
            </Panel>
          </div>
        </>
      )}
      <section className="wide-replay-column"><h2>{c("matches")}</h2><Replays /></section>
    </div>
  );
}
